import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var TwitterLogoIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    d: "M22 5.893a8.291 8.291 0 01-2.356.636 4.07 4.07 0 001.804-2.234 8.35 8.35 0 01-2.607.981A4.12 4.12 0 0015.846 4c-2.266 0-4.103 1.81-4.103 4.04 0 .316.036.625.106.92a11.708 11.708 0 01-8.456-4.222A3.964 3.964 0 002.84 6.77c0 1.402.724 2.64 1.824 3.363a4.15 4.15 0 01-1.858-.507v.05c0 1.958 1.415 3.59 3.29 3.963a4.215 4.215 0 01-1.08.141c-.266 0-.522-.026-.773-.075a4.098 4.098 0 003.832 2.806 8.312 8.312 0 01-5.095 1.727A8.85 8.85 0 012 18.182 11.727 11.727 0 008.289 20c7.547 0 11.673-6.157 11.673-11.496l-.014-.523A8.126 8.126 0 0022 5.893z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(TwitterLogoIcon);